










































 import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
 import Modal from '@/components/agroGenericModal/AgroGenericModal.vue';
 import AgroIcons from '@/components/agroIcons/AgroIcons.vue';

 @Component({
   name: 'SecretKeyModal',
   components: {
      Modal,
      AgroIcons,
   }
 })

export default class SecretKeyModal extends Vue {
  @Prop(String)
  private secretKey!: string;
  private canCopy = !!navigator.clipboard;
  private copied = false;

  private inputType = 'password';

  @Emit()
  private close() {}

  private toggleSecret() {
    this.inputType = (this.inputType === 'password') ? 'text' : 'password';
  }

  private async copyToClipboard() {
    try {
      await navigator.clipboard.writeText(this.secretKey);
      this.copied = true;
    } catch {}
  }
}
